import React, { useState } from 'react';
import Button from '../common/Button';
import ClaimModal from '../claim/ClaimModal';
import { useContractState } from '../../context/ContractContext';
import { formatUSDT, bpToPct } from '../../utils/format';

export default function ClaimMegaCard() {
  const { claimInfo, basic, fees } = useContractState();
  const [open, setOpen] = useState(false);

  const pending  = claimInfo ? claimInfo.pending      : (basic && basic.pendingRewards);
  const netAll   = claimInfo ? claimInfo.netIfClaimAll : null;
  const feeBps   = claimInfo ? claimInfo.feeBps        : (fees && fees.claimFee);

  return (
    <div className="claim-mega">
      <div className="head">
        <div className="title">Pending Rewards</div>
        <span className="fee-chip">Fee {bpToPct(feeBps || 0)}</span>
      </div>
      <div className="amount">{formatUSDT(pending)}</div>
      {netAll && <div className="net">You receive {formatUSDT(netAll)} after fee</div>}
      <div className="actions">
        <Button variant="success" block size="lg" onClick={() => setOpen(true)}>
          💰 Claim Now
        </Button>
      </div>
      <ClaimModal open={open} onClose={() => setOpen(false)} />
    </div>
  );
}
